import { createSlice } from "@reduxjs/toolkit";

export const platforms = createSlice({
  name: "platforms",
  initialState: {
    list : [],
    names: [],
  },
  reducers: {
    setPlatformsList : (state, action) => {
      if(action.payload) state.list = action.payload
    },
    updatePlatform : (state, action) =>{
      if(action.payload) state.list = state.list.map((platform) =>
      platform.id == action.payload.id ? action.payload : platform
      );
    },
    updatePlatforms: (state, action) => {
      console.log("Initiating platform update", action.payload)
      if (action.payload) {
        // update the list of platforms if the item exists
        console.log("updating platforms")
        state.list = state.list.map((platform) => {
          const updatedPlatform = action.payload.find((item) => item.id === platform.id);
          return updatedPlatform ? updatedPlatform : platform;
        });
        // add the items that do not exist
        console.log("adding platforms")
        action.payload.forEach((newPlatform) => {
          const foundIndex = state.list.findIndex((platform) => platform.id === newPlatform.id);
          if (foundIndex === -1) {
            state.list.push(newPlatform);
          } else {
            state.list[foundIndex] = newPlatform;
          }
        });
      }
    },        
    setPlatformsNames : (state, action) => {
      if(action.payload) state.names = action.payload
    },
  }
});

export default platforms.reducer

export const selectAllPlatforms = state=>state.platforms.list.filter(platform=>platform.isDeleted === false)
export const selectAllDeletedPlatforms = state=>state.platforms.list.filter(platform=>platform.isDeleted === true)
export const selectAllPlatformNames = state=>state.platforms.names

export const selectActivePlatformForUser = (userId) => (state) => {
  console.log("selectActivePlatformForUser: " , state.platforms.list);

  const activePlatforms = state.platforms.list.filter(
    (platform) => {
      // Check that platform.buyingEmailid exists before searching
      if (!platform.buyingEmailId) {
        return false;
      }
      
      // Search for the corresponding buyingEmail in the buyingEmails store
      const buyingEmail = state.buyingEmails.list.find((email) => email.id === platform.buyingEmailId);

      // Check that buyingEmail exists and that its assignedUserID is the correct one
      return buyingEmail && buyingEmail.assignedUserID === userId && !platform.isDeleted;
    }
  );

  return activePlatforms || [];
};

export const { setPlatformsList, setPlatformsNames, updatePlatform, updatePlatforms } = platforms.actions;